import React, { useEffect } from 'react'
import { useParams, useRouteMatch } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { selectJobs } from '../selectors/scripting'
import { removeObject } from '../helpers/utilHelper'
import { State, Dispatch } from '../store'
import { useSelector, useDispatch } from 'react-redux'
import { selectActiveAccountId } from '../selectors/accounts'
import { Stack } from '@mui/material'
import { ScriptingHeader } from '../components/ScriptingHeader'
import { LoadingMessage } from '../components/LoadingMessage'
import { jobAttributes } from '../components/JobAttributes'
import { JobList } from '../components/JobList'
import { Notice } from '../components/Notice'
import { Body } from '../components/Body'

export const JobsPage: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch<Dispatch>()
  const { fileID } = useParams<{ fileID?: string }>()
  const jobMatch = useRouteMatch<{ jobID: string }>('/runs/job/:jobID')
  const [required, attributes] = removeObject(jobAttributes, a => a.required === true)
  const jobs = useSelector((state: State) => selectJobs(state, undefined, fileID))
  const accountId = useSelector(selectActiveAccountId)
  const columnWidths = useSelector((state: State) => state.ui.columnWidths)
  const fetching = useSelector((state: State) => state.ui.fetching || state.jobs.fetching)

  useEffect(() => {
    dispatch.jobs.fetch({ fileID })
  }, [accountId, fileID])

  return (
    <ScriptingHeader>
      {fetching && !jobs.length ? (
        <LoadingMessage />
      ) : !jobs.length ? (
        <Body center>
          <Stack alignItems="center">
            <Notice gutterBottom>{t('jobsPage.runScriptToStart', 'Run a script to get started')}</Notice>
          </Stack>
        </Body>
      ) : (
        <JobList
          attributes={attributes}
          {...{ required, jobs, columnWidths, fetching }}
          activeJobId={jobMatch?.params.jobID}
          jobOnlyRoute
          loadMore
        />
      )}
    </ScriptingHeader>
  )
}
